declare global {
  interface Window {
    Optanon: {
      ToggleInfoDisplay: () => void;
    };
  }
}

const openPreferenceCenterLinkHash = '#js-open-onetrust-preference-center';
const openPreferenceCenterLinkSelector = `a[href="${openPreferenceCenterLinkHash}"]`;

const toggleOneTrustPreferenceCenter = (): void => {
  document.querySelector(openPreferenceCenterLinkSelector)?.addEventListener('click', (event: Event) => {
    event.preventDefault();
    if (window.Optanon && typeof window.Optanon.ToggleInfoDisplay === 'function') {
      window.Optanon.ToggleInfoDisplay();
    }
  });
};

if (document.readyState !== "loading") {
  toggleOneTrustPreferenceCenter();
} else {
  document.addEventListener("DOMContentLoaded", toggleOneTrustPreferenceCenter);
}

// Used for Typescript module scope
export {};
